import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import Context from '../../../context/Context';
import Rdx from '../../../redux/Rdx';

import "@esri/calcite-components/dist/components/calcite-button";
import "@esri/calcite-components/dist/components/calcite-modal";
import {
  CalciteButton,
  CalciteModal
} from "@esri/calcite-components-react";

export default class ModalController {

  qqq = "qqq"

  confirm() {

  }

  show(options?: any) {
    options = options || {};
    const i18n = Context.instance.i18n;
    let node = document.createElement("div");
    document.body.appendChild(node);
    let root = createRoot(node);

    const close = () => {
      try {
        if (root) root.unmount()
       } catch(ex) {
         console.error(ex)
       }
       root = null
       try {
        if (node) node.parentNode.removeChild(node)
       } catch(ex) {
         console.error(ex)
       }
       node = null
    }

    const ok = () => {
      if (typeof options.onOK === "function") {
        options.onOK();
      }
      close();
    }
    let width:any="m";
    if(options && options.small) width="s";
      
    root.render(
      <React.StrictMode>
        <Provider store={Rdx.store}>
          <CalciteModal className="g-modal-50" open={true} onCalciteModalClose={close} width={width}>
            <div slot="header">{options.title}</div>
            <div slot="content">{options.content}</div>
            <CalciteButton slot="secondary" width="full" appearance="outline" onClick={close}>
              {options.cancelLabel || i18n.general.cancel}
            </CalciteButton>
            <CalciteButton slot="primary" width="full" onClick={ok}>
              {options.okLabel || i18n.general.ok}
            </CalciteButton>
          </CalciteModal>
        </Provider>
      </React.StrictMode>
    )

  }

}